import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import ContactSection from '../components/sections/ContactSection';

const Contact = () => {
  return (
    <div className="min-h-screen bg-royal-navy">
      <PageHeader title="Contact Us" />
      <ContactSection />
    </div>
  );
};

export default Contact;